/**
 * Human-readable user name for lists and titles. Agent-registered users and
 * pending members can have null first/last names, and a naive
 * `${firstName} ${lastName}` renders "null null" (AIT-52). Falls back to the
 * email, then an em-dash placeholder.
 */
export function userDisplayName(user: {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}): string {
  return userNameOrNull(user) || user.email?.trim() || '—';
}

/**
 * Just the name part, or null when the user has none. JSX sites use this so
 * the email fallback renders through <RedactedEmail /> (masked by default,
 * per the screen-share-safe convention) instead of leaking the raw address.
 */
export function userNameOrNull(user: {
  firstName?: string | null;
  lastName?: string | null;
}): string | null {
  const name = [user.firstName, user.lastName]
    .filter((part) => part?.trim())
    .join(' ')
    .trim();
  return name || null;
}
